export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mobile_banner_logo.409d955.png";